import React, {Component} from 'react';

/** @class EditorPanel
  * A component for displaying multiple EditorColumns
  */
export default class EditorPanel extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div className="editor-panel">
        {this.props.children}
      </div>
    )
  }
}

EditorPanel.propTypes = {}



// WEBPACK FOOTER //
// ./src/editor-components/editor-panel.js